import { styled } from 'styled-components';
import { createPortal } from 'react-dom';
import React from 'react';

interface OverlayProps {
  isVisible: boolean;
  zIndex?: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const Overlay: React.FC<OverlayProps> = ({ isVisible, zIndex, onClick }) => {
  if (!isVisible) return null;

  return createPortal(
    <StyledOverlay $zIndex={zIndex} onClick={onClick} />,
    document.body
  );
};

const StyledOverlay = styled.div<{ $zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(29, 27, 32, 0.6);
  z-index: ${({ $zIndex, theme }) => $zIndex ?? theme.zIndex.modal};
  backdrop-filter: blur(4px);
`;